import '/src/styles/faq.css';
import FAQContent from "../../../../src/pages/faq/faq.md";
import * as React from 'react';
export default {
  FAQContent,
  React
};